import { FiArrowLeft, FiSearch } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';

import {
  ButtonContainer,
  Container,
  Description,
  ErrorCode,
  IconContainer,
  SecondaryButton,
  Title,
} from './styles';

export const Page404 = () => {
  const location = useLocation();
  const history = useHistory();

  /* eslint-disable no-console */
  console.log(location.pathname);
  /* eslint-enable no-console */

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Container>
      <IconContainer>
        <FiSearch />
      </IconContainer>

      <ErrorCode>404</ErrorCode>

      <Title>Página não encontrada</Title>

      <Description>
        Ops! Parece que você se perdeu no caminho. A página que você está
        procurando não existe ou foi movida.
        <br />
        Não se preocupe, estamos aqui para ajudar você a encontrar o que
        precisa.
      </Description>

      <ButtonContainer>
        <SecondaryButton onClick={handleGoBack}>
          <FiArrowLeft />
          Voltar
        </SecondaryButton>
      </ButtonContainer>
    </Container>
  );
};
